import { localization } from "./localization";


export type LanguageKeys = keyof (typeof localization);
export type LanguageType = { [key in LanguageKeys]: string }
export const languageKeyList = Object.keys(localization);

export enum LockMeasurements {
  None = 0,
  Name = 1 << 0,
  Length = 1 << 1,
  Unit = 1 << 2,
  Area = 1 << 3,
  AllButName = Length | Unit | Area,
  All = Name | Length | Unit | Area
}

export type Settings = {
  lang: LanguageKeys;
  transitionDuration: number;
};

export type FilterDef = {
  displayName: LanguageType; // name to be displayed.
  defaultValue: number;
  minValue: number;
  maxValue: number;
  step: number;
  transform: (val: number) => string; // get the transform string from the filter value
};

export type LicenseItem = {
  licenses: string;
  repository: string;
  licenseUrl: string;
  parents: string;
};

export type ImgCategory = {
  key: string;
  name: LanguageType;
  subHeading?: LanguageType;
};

export type ImgItem = {
  src: string;
  name: LanguageType;
  width?: number;
  unit?: string;
  magnification?: number;
  categories: string[];
  id: string;
  description: LanguageType;
};

export type CollectionInfo = {
  homepage?: string;
  logo?: string;
};

export type ImgCollection = {
  [K in LanguageKeys]?: CollectionInfo;
} & {
  categories: ImgCategory[];
  images: ImgItem[];
};

export type ImageSrc = {
  src: string;
  name: LanguageType | string;
  unit?: string;
  pixel?: number;
  width?: number;
  height?: number;
  magnification?: number;
  id?: string;
  categoryKey?: string;
  imageIdx?: number;
};

const optionsPrototype = {
  src: '',
  name: '',
  width: 0,
  height: 0,
  pixel: 0,
  unit: '',
  collapsed: true,
  allowExternalSrc: true,
  lang: 'en' as LanguageKeys,
  allowEdit: true,
  openCat: '',
  id: ''
};
export const commonOptions = Object.keys(optionsPrototype);

export type CommonOptionsType = {
  [K in keyof (typeof optionsPrototype)]?: (typeof optionsPrototype)[K];
};

export interface OptionsType extends CommonOptionsType {
  [key: string]: any;
}

// different depending on environment (desktop or web)
export type OpenFileHandle = {
  open: () => Promise<File>;
};
export type SaveFileHandle = {
  save: (blob: Blob) => Promise<void>
};